module.exports = [
  'get',
  'post',
  'put',
  'head',
  'delete',
  'options',
  'trace',
  'copy',
  'lock',
  'mkcol',
  'move',
  'purge',
  'propfind',
  'proppatch',
  'unlock',
  'report',
  'mkactivity',
  'checkout',
  'merge',
  'm-search',
  'notify',
  'subscribe',
  'unsubscribe',
  'patch',
  'search',
  'connect'
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/superagent-defaults/lib/methods.js
 ** module id = 227
 ** module chunks = 0 1 6 7 8 9
 **/